<template>
	<div class="Search">
		<div class="search-input">
			<van-search placeholder="请输入关键字" v-model="searchKeyWord" @search="goSearchResult"/>
			<button @click="goSearchResult">搜索</button>
		</div>
		<!-- <div class="recommend block">
			<h3>推荐</h3>
			<div>
				<span v-for="(item,index) in hotGoodsWords" :key="index" @click="clickKeyWord(item)" class="line-clamp-1">{{item}}</span>			
			</div>
		</div> -->
		<!-- <div class="hr-7"></div> -->
		<div class="history block">
			<h3>历史</h3>
			<div>
				<span v-for="(item,index) in historyWords" :key="index" @click="clickKeyWord(item)" class="line-clamp-1">{{item}}</span>
			</div>
		</div>
	    <div class="clear" @click="clearHistory">
				清空历史搜索
		</div>
	</div>
</template>
<script>
	import {ExpertInfo} from "@/components/Expert/ExpertInfo"
	export default{

		data(){
			return{
				hotGoodsWords:[],
				searchKeyWord:'',     //关键词
				historyWords:[],      //历史搜索
			}
		},
		mounted(){
			this.getHistoryWords();
		},
		methods:{
			//获取输入框里输入的关键词
			searchInput(){
				this.searchKeyWord=(this.searchKeyWord).replace(/(^\s*)|(\s*$)/g, '');
				console.log(this.searchKeyWord);
			},
			//获取本地存储的关键词
			getHistoryWords(){
				let historyWords=localStorage.getItem('historyWords');
				if(historyWords){
					this.historyWords=JSON.parse(historyWords);
				}else{
					this.historyWords=[];
				}
			},
			//点击搜索的标签
			clickKeyWord(word){
				this.searchKeyWord=word;
				this.goSearchResult();
			},
			//跳转到搜索结果页	
			goSearchResult(){
				this.searchKeyWord=(this.searchKeyWord).replace(/(^\s*)|(\s*$)/g, '');
				if(this.searchKeyWord==''){
					common.toast('请输入搜索内容',1000)
				}else{
					let array=[];
					array.push(this.searchKeyWord);
					let historyWords=null;
					historyWords=localStorage.getItem('historyWords');
					if(historyWords){
						let data=JSON.parse(historyWords);
						for(let i=0;i<data.length;i++){
							if(array.indexOf(data[i])==-1){
								array.push(data[i])
							}
						}
					} 
					localStorage.setItem('historyWords',JSON.stringify(array));
					this.getHistoryWords();
					this.$router.push({
						name:'SearchList',
						query:{
							searchKeyWord:this.searchKeyWord
						}
					})					
				}
			},
			//清空搜索历史
			clearHistory:function(){
				localStorage.removeItem('historyWords');
				this.getHistoryWords();
			}				

		}
	}
</script>
<style lang="scss">
	.Search{
		.search-input{
			display:flex;
			padding:15px 12px;
			.van-search{
				padding:0px;
				flex:1;
			}
			.van-search__content{
				background: #FFFFFF;
				border: 1px solid #D3D3D3;
				border-radius: 3px;
				::-webkit-input-placeholder,i{
					color:#999;
					font-size:14px;
				}
				i{
					font-size:18px;
				}
			}
			button{
				color:#fff;
				border:0px;
				background: #FF504F;
				border-radius: 0 5px 5px 0;
				width:62px;
				height:36px;
				margin-left:-2px;
			}
		}
		.block{
			padding-left:12px;
			margin-bottom:15px;
			div{
				@include flex(row);
				flex-wrap:wrap;
			}
			h3{
				font-size: 17px;
				color: #090909;
				letter-spacing: 0.6px;
				margin:15px 0;
			}
			span{
				font-size:14px;
				color:#090909;
				display:-webkit-box;
				height:36px;
				line-height:36px;
				width:80px;
				text-align:center;
				border: 1px solid #D3D3D3;
				border-radius: 2px;
				margin-right:8px;
				margin-bottom:13px;
			}
			span:nth-child(4n){
				margin-right: 0px;
			}
		}
		.clear{
			padding:15px 0;
			border-top:1px solid #d3d3d3;
			font-size:14px;
			color:#989898;
			text-align:center;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Vow/Search/Index.vue